import type { ProductWithDetails, Laboratory } from '../types';
import { DELIVERY_TIMES } from '../constants';

export const validateProductData = (data: ProductWithDetails): boolean => {
  try {
    if (!data.Nombre || typeof data.Nombre !== 'string' || data.Nombre.trim() === '') {
      console.error('Nombre inválido');
      return false;
    }

    if (!data.Categoria || typeof data.Categoria !== 'string') {
      console.error('Categoría inválida');
      return false;
    }

    if (!Array.isArray(data.laboratories) || data.laboratories.length === 0) {
      console.error('Laboratorios inválidos');
      return false;
    }

    if (typeof data.Factor !== 'number' || data.Factor <= 0) {
      console.error('Factor inválido');
      return false;
    }

    return data.laboratories.every(lab => {
      if (!lab.laboratory?.id) {
        console.error('ID de laboratorio faltante');
        return false;
      }
      
      if (typeof lab.details.PrecioDeCosto !== 'number' || lab.details.PrecioDeCosto <= 0) {
        console.error('Precio de costo inválido');
        return false;
      }
      
      if (!DELIVERY_TIMES.includes(lab.details.TiempoDeDemora as typeof DELIVERY_TIMES[number])) {
        console.error('Tiempo de demora inválido');
        return false;
      }
      
      return true;
    });
  } catch (error) {
    console.error('Error en validación:', error);
    return false;
  }
};

export const validateLaboratoryData = (data: Laboratory): boolean => {
  return !!(
    data.Nombre && 
    typeof data.Nombre === 'string' &&
    data.Ubicación && 
    typeof data.Ubicación === 'string' &&
    data.Contacto && 
    typeof data.Contacto === 'string' &&
    data.Teléfono && 
    typeof data.Teléfono === 'string'
  );
};